import React from 'react'
import s from './TrafficHomeMainContent.less'
import Footer from '../footer/Footer'
import TrafficCityIntroduction from './TrafficCityIntroduction'
import LayerCityFaq from '../seo/FAQ/LayerCityFaq'
import CityDescription from '../address/CityDescription'
import TrafficCityHPLayerLinks from '../seo/CityLayerLinks'
import AutoPromoGE from '../autopromo/AutoPromoGE'

const TrafficCityMainContent = () => (
  <>
    <div className={s.root}>
      <AutoPromoGE className={s.autopromo} />
      <TrafficCityIntroduction />
      <div className={s.descriptionWrapper}>
        <CityDescription />
      </div>
      <LayerCityFaq />
      <TrafficCityHPLayerLinks />
    </div>
    <Footer />
  </>
)

export default TrafficCityMainContent
